import { RootState } from 'editor/src/store/index';

const getLoadingMoreAddons = (state: RootState): boolean => state.editorModules.addons.loadingMore ?? false;

export default getLoadingMoreAddons;
